import styled from "styled-components";
import {StyledProfileWidgetWrapper} from "../../upcoming-calls/profile-widget/profile-widget.style";

export const StyledShareServiceWidgetWrapper = styled(StyledProfileWidgetWrapper)`
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 2.4rem;
  @media only screen and (max-width: 960px) {
    margin-top: 2.4rem;
  }
`;
